export const imageUrl = localStorage.getItem("showImgUrlDms") !== null ? localStorage.getItem("showImgUrlDms") : "";

export const googleAddressUrl = "https://maps.googleapis.com/maps/api/geocode/json?latlng=";

export const googleApiKey = localStorage.getItem("googleApiKey") || null;
